export let base_url="https://wtsacademy.dedicateddevelopers.us/";
export let end_points={
    register:"api/user/signup",
    login:"api/user/signin",
    profile:"api/user/profile-details"
}